import { api } from "./api";

const CACHE_KEY = "@Inoveclube:businessCache";
const pendingRequests = new Map();

function readCache(nameBusiness, token, maxAge) {
	try {
		const cache = JSON.parse(sessionStorage.getItem(CACHE_KEY));
		const isValid =
			cache?.nameBusiness === nameBusiness &&
			cache.token === token &&
			Date.now() - cache.fetchedAt <= maxAge;

		return isValid ? { data: cache.data } : null;
	} catch (error) {
		return null;
	}
}

function writeCache(nameBusiness, token, data) {
	try {
		sessionStorage.setItem(
			CACHE_KEY,
			JSON.stringify({ nameBusiness, token, fetchedAt: Date.now(), data }),
		);
	} catch (error) {
		// sessionStorage cheio ou indisponível: segue sem cache.
	}
}

/**
 * Busca os dados da empresa na rota /getBusiness.
 * Com maxAge (ms), reaproveita a última resposta salva no sessionStorage, que
 * sobrevive ao reload feito ao sair do cardápio para /shopping.
 * Chamadas simultâneas compartilham a mesma requisição.
 * Resolve no mesmo formato da resposta do axios ({ data }).
 */
export function fetchBusiness(nameBusiness, { maxAge = 0 } = {}) {
	const token = localStorage.getItem("@Inoveclube:token");

	if (maxAge > 0) {
		const cached = readCache(nameBusiness, token, maxAge);
		if (cached) return Promise.resolve(cached);
	}

	const requestKey = `${nameBusiness}/${token}`;

	if (!pendingRequests.has(requestKey)) {
		const request = api
			.get(`/getBusiness/${nameBusiness}/${token}`)
			.then((response) => {
				writeCache(nameBusiness, token, response.data);
				return response;
			})
			.finally(() => pendingRequests.delete(requestKey));

		pendingRequests.set(requestKey, request);
	}

	return pendingRequests.get(requestKey);
}
